import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.div`
	font-size: ${helpers.font.size.small};
	color: ${helpers.color.textMuted};
`
